module.exports = __webpack_public_path__ + "static/media/screenshot(46).e590fcb7.jpg";